import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';

const NumeralFormat = props => {
  const { value, numericFormat, format, enabled } = props;

  if (enabled && format) {
    return <div className="pxl-input-number__format">{format(numeral(value).format(numericFormat))}</div>;
  }
  return null;
};

NumeralFormat.propTypes = {
  enabled: PropTypes.bool,
  format: PropTypes.func,
  numericFormat: PropTypes.string,
  value: PropTypes.any
};

NumeralFormat.defaultProps = {
  enabled: false,
  numericFormat: '0,0'
};

export default NumeralFormat;
